import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Bar } from 'react-chartjs-2'

const options = {
  indexAxis: 'x',
  responsive: true,
  aspectRatio: 1,
  maintainAspectRatio: false,

  plugins: {
    // title: {
    //   display: true,
    //   position: 'bottom',
    //   text: '',
    //   color: 'white',
    // },
    datalabels: {
      display: false,
    },
    legend: {
      position: 'right',
      labels: {
        color: 'rgba(255,255,255,0.78)',
        usePointStyle: true,
      },
    },
  },
  scales: {
    x: {
      stacked: true,
      grid: { color: 'rgba(255,255,255,0.06)' },
      ticks: { color: 'rgba(255,255,255,0.75)' },
    },
    y: {
      stacked: true,
      grid: { color: 'rgba(255,255,255,0.06)' },
      ticks: { color: 'rgba(255,255,255,0.75)' },
    },
  },
}
export default function Chart3({ chartData }) {
  const color_list = [
    '#5aa1d8',
    '#ef7d56',
    '#7cc6b2',
    '#f2b84b',
    '#a987ff',
    '#d8e8f6',
    '#2f8ee8',
    '#c9577c',
    '#61b894',
    '#f08a5d',
    '#5aa1d8',
    '#ef7d56',
    '#7cc6b2',
    '#f2b84b',
    '#a987ff',
  ]
  const [labels, setlabels] = useState([])
  const [datasets, setDatasets] = useState([
    {
      label: '',
      data: [],
      backgroundColor: ['#60829b'],
      borderColor: ['#60829b'],
      barThickness: 20,
    },
  ])
  useEffect(() => {
    if (chartData) {
      setlabels(chartData.labels)
      let setdata = []
      chartData.data.forEach((e, index) => {
        setdata.push({
          label: e.label,
          data: e.data,
          backgroundColor: color_list[index],
          borderColor: color_list[index],
          barThickness: 20,
        })
      })
      setDatasets(setdata)
    }
  }, [chartData])
  const data = {
    labels,
    datasets,
  }
  return (
    <Box height={350} position={'relative'} width={'100%'}>
      <Bar data={data} options={options} />
    </Box>
  )
}
